<template>
  <div class="table-contents">
    <h1 id="toc">Table of Contents</h1>
    <div style="display: table;">
      <a href="javascript:void(0);" @click="goToByScroll('acknowledgements')" class="table-row">
        <span class="table-cell bold">Acknowledgements and Contributions</span>
      </a>
      <a href="javascript:void(0);" @click="goToByScroll('bc-provincial-stop')" class="table-row">
        <span class="table-cell bold">BC Provincial STOP Program</span>
      </a>
      <a href="javascript:void(0);" @click="goToByScroll('interpreting')" class="table-row">
        <span class="table-cell bold">A Note on Monitoring and Interpreting HIV Indicators</span>
      </a>
    </div>

    <div>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll(1)">
        <span class="table-cell fixed-column bold">Indicator 1</span>
        <span class="table-cell"><b>HIV Testing Episodes</b> <i>All HIV Testing Episodes reflect non-prenatal tests. All prenatal tests have been removed.</i></span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('1-1')">
        <span class="table-cell fixed-column">Figure 1.1</span>
        <span class="table-cell">HIV Test Episodes for {{this.$parent.haName}}, {{this.$parent.period}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('1-2')">
        <span class="table-cell fixed-column">Figure 1.2</span>
        <span class="table-cell">HIV Test Episodes for {{this.$parent.haName}} by Gender, {{this.$parent.period}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('1-3')">
        <span class="table-cell fixed-column">Figure 1.3</span>
        <span class="table-cell">HIV Test Episodes for {{this.$parent.haName}} by Age Category, {{this.$parent.period}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('1-4')">
        <span class="table-cell fixed-column">Figure 1.4</span>
        <span class="table-cell">Point-of-Care HIV Tests for {{this.$parent.haName}}, {{this.$parent.period}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('1-5')">
        <span class="table-cell fixed-column">Figure 1.5</span>
        <span class="table-cell">HIV Test Episodes by {{this.$parent.groupBy}} for {{this.$parent.haName}}, {{this.$parent.period}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('1-6')">
        <span class="table-cell fixed-column">Figure 1.6</span>
        <span class="table-cell">HIV Test Episodes for Non-Prenatal Females in {{this.$parent.haName}} by {{this.$parent.groupBy}}, {{this.$parent.period}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('1-7')">
        <span class="table-cell fixed-column">Figure 1.7</span>
        <span class="table-cell">HIV Test Episodes for Males in {{this.$parent.haName}} by {{this.$parent.groupBy}}, {{this.$parent.period}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('2')">
        <span class="table-cell fixed-column bold">Indicator 2</span>
        <span class="table-cell"><b>HIV Testing Rates</b> <i>All HIV Testing Rates reflect non-prenatal tests. All prenatal tests have been removed</i></span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('2-1')">
        <span class="table-cell fixed-column">Figure 2.1</span>
        <span class="table-cell">Rate of HIV Testing for {{this.$parent.haName}} and {{this.$parent.groupByPlural}}, 2009–2017</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('2-2')">
        <span class="table-cell fixed-column">Figure 2.2</span>
        <span class="table-cell">Rate of HIV Testing for {{this.$parent.haName}} by Gender, 2009–2017</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('2-3')">
        <span class="table-cell fixed-column">Figure 2.3</span>
        <span class="table-cell">Rate of HIV Testing for {{this.$parent.haName}} by Age Category, 2009–2017</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('3')">
        <span class="table-cell fixed-column bold">Indicator 3</span>
        <span class="table-cell bold">New HIV Diagnoses</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('3-1')">
        <span class="table-cell fixed-column">Figure 3.1</span>
        <span class="table-cell">New HIV Diagnoses for {{this.$parent.haName}}, {{this.$parent.period}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('3-2')">
        <span class="table-cell fixed-column">Figure 3.2</span>
        <span class="table-cell">New HIV Diagnoses for {{this.$parent.haName}} by Gender, {{this.$parent.period}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('3-3')">
        <span class="table-cell fixed-column">Figure 3.3</span>
        <span class="table-cell">New HIV Diagnoses for {{this.$parent.haName}} by Age Category, {{this.$parent.period}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('3-4')">
        <span class="table-cell fixed-column">Figure 3.4</span>
        <span class="table-cell">New HIV Diagnoses for {{this.$parent.haName}} by Exposure Category, 2012 Q4-2017-Q3</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('3-5')">
        <span class="table-cell fixed-column">Figure 3.5</span>
        <span class="table-cell">New HIV Diagnoses for {{this.$parent.haName}} by {{this.$parent.groupBy}}, {{this.$parent.period}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('4')">
        <span class="table-cell fixed-column bold">Indicator 4</span>
        <span class="table-cell"><b>Stage of HIV Infection at Diagnosis</b> <i>Stage definitions have been altered to remove
          AIDS diagnosis data. Individuals previously classified as Stage 3 have been re-classified based on CD4 cell count.</i></span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('table1')">
        <span class="table-cell fixed-column">Table 1</span>
        <span class="table-cell">Staging Classifications of Infection at Time of HIV Diagnosis Based on CDC HIV Surveillance Case Definitions</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('4-1')">
        <span class="table-cell fixed-column">Figure 4.1</span>
        <span class="table-cell">Stage of HIV Infection at Diagnosis for {{this.$parent.haName}}, 2013–2017</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('4-2')">
        <span class="table-cell fixed-column">Figure 4.2</span>
        <span class="table-cell">Stage of HIV Infection at Diagnosis for {{this.$parent.haName}} by Gender, 2013–2017</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('4-3')">
        <span class="table-cell fixed-column">Figure 4.3</span>
        <span class="table-cell">Stage of HIV Infection at Diagnosis for {{this.$parent.haName}} by Age Category, 2013–2017</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('4-4')">
        <span class="table-cell fixed-column">Figure 4.4</span>
        <span class="table-cell">Stage of HIV Infection at Diagnosis for {{this.$parent.haName}} by Exposure Category, 2013–2017</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('5')">
        <span class="table-cell fixed-column bold">Indicator 5</span>
        <span class="table-cell bold">HIV Cascade of Care</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('5-1')">
        <span class="table-cell fixed-column">Figure 5.1</span>
        <span class="table-cell">Estimated Cascade of Care for {{this.$parent.haName}}, Year Ending {{this.$parent.lastYear}} Q{{this.$parent.lastQuarter}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('5-2')">
        <span class="table-cell fixed-column">Figure 5.2</span>
        <span class="table-cell">Estimated Cascade of Care for {{this.$parent.haName}} by Gender, Year Ending {{this.$parent.lastYear}} Q{{this.$parent.lastQuarter}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('5-3')">
        <span class="table-cell fixed-column">Figure 5.3</span>
        <span class="table-cell">Estimated Cascade of Care for {{this.$parent.haName}} by Age Category, Year Ending {{this.$parent.lastYear}} Q{{this.$parent.lastQuarter}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('5-4')">
        <span class="table-cell fixed-column">Figure 5.4</span>
        <span class="table-cell">Estimated Cascade of Care for {{this.$parent.haName}} by MSM Status, Year Ending {{this.$parent.lastYear}} Q{{this.$parent.lastQuarter}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('5-5')">
        <span class="table-cell fixed-column">Figure 5.5</span>
        <span class="table-cell">Estimated Cascade of Care for {{this.$parent.haName}} by Age Category and MSM Status, Year Ending {{this.$parent.lastYear}} Q{{this.$parent.lastQuarter}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('5-6')">
        <span class="table-cell fixed-column">Figure 5.6</span>
        <span class="table-cell">Estimated Cascade of Care for {{this.$parent.haName}} by PWID Status, Year Ending {{this.$parent.lastYear}} Q{{this.$parent.lastQuarter}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('5-7')">
        <span class="table-cell fixed-column">Figure 5.7</span>
        <span class="table-cell">Estimated Cascade of Care for {{this.$parent.haName}} by {{this.$parent.groupBy}}, Year Ending {{this.$parent.lastYear}} Q{{this.$parent.lastQuarter}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('6')">
        <span class="table-cell fixed-column bold">Indicator 6</span>
        <span class="table-cell bold">Programmatic Compliance Score (PCS)</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('table2')">
        <span class="table-cell fixed-column">Table 2</span>
        <span class="table-cell">Probability of Mortality, Immunologic Failure and Virologic Failure Based on the Programmatic Compliance Score</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('6-1')">
        <span class="table-cell fixed-column">Figure 6.1</span>
        <span class="table-cell">
          <div style="padding-bottom: 12px;">PCS Components for {{this.$parent.haName}}, 2016 Q3–{{this.$parent.lastYear}} Q{{this.$parent.lastQuarter}}</div>
          <div style="padding-left: 30px; padding-bottom: 12px;">Less than 3 CD4 Tests in First Year</div>
          <div style="padding-left: 30px; padding-bottom: 12px;">Less than 3 Viral Load Tests in First Year</div>
          <div style="padding-left: 30px; padding-bottom: 12px;">Not Having Drug Resistance Testing at Baseline</div>
          <div style="padding-left: 30px; padding-bottom: 12px;">Non-Recommended Antiretroviral Therapy Regimen (ART)</div>
          <div style="padding-left: 30px; padding-bottom: 12px;">Baseline CD4 < 200 cells/µL</div>
          <div style="padding-left: 30px;">Not Achieving Viral Suppression at 9 Months</div>
        </span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('6-2')">
        <span class="table-cell fixed-column">Figure 6.2</span>
        <span class="table-cell">Historical Trends for PCS Score for {{this.$parent.haName}}, 2016 Q3–{{this.$parent.lastYear}} Q{{this.$parent.lastQuarter}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('7a')">
        <span class="table-cell fixed-column bold">Indicator 7</span>
        <span class="table-cell bold">New Antiretroviral Therapy Starts in {{this.$parent.haName}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('7')">
        <span class="table-cell fixed-column">Figure 7</span>
        <span class="table-cell">
          BC-CfE Drug Treatment Program Enrollment:<br />
          <span>New Antiretroviral Participants for {{this.$parent.haName}}, 2016 Q3–{{this.$parent.lastYear}} Q{{this.$parent.lastQuarter}}</span>
        </span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('8a')">
        <span class="table-cell fixed-column bold">Indicator 8</span>
        <span class="table-cell bold">CD4 Cell Count at ART Initiation</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('8')">
        <span class="table-cell fixed-column">Figure 8</span>
        <span class="table-cell">CD4 Cell Count at ART Initiation for {{this.$parent.haName}}, 2016 Q3–{{this.$parent.lastYear}} Q{{this.$parent.lastQuarter}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('9a')">
        <span class="table-cell fixed-column bold">Indicator 9</span>
        <span class="table-cell bold">Active and Inactive Drug Treatment Program (DTP) Participants</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('table3')">
        <span class="table-cell fixed-column">Table 3</span>
        <span class="table-cell">Distribution of People on ART in {{this.$parent.haName}}, {{this.$parent.lastYear}} Q{{this.$parent.lastQuarter}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('9')">
        <span class="table-cell fixed-column">Figure 9</span>
        <span class="table-cell">Active and Inactive DTP Participants for {{this.$parent.haName}}, 2016 Q3–{{this.$parent.lastYear}} Q{{this.$parent.lastQuarter}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('10a')">
        <span class="table-cell fixed-column bold">Indicator 10</span>
        <span class="table-cell bold">Antiretroviral Adherence</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('10')">
        <span class="table-cell fixed-column">Figure 10</span>
        <span class="table-cell">
          Distribution of Individuals by Adherence Level in 1st Year of Therapy,<br />
          <span>Based on Pharmacy Refill Compliance for {{this.$parent.haName}}, 2016 Q3–{{this.$parent.lastYear}} Q{{this.$parent.lastQuarter}}</span>
        </span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('11a')">
        <span class="table-cell fixed-column bold">Indicator 11</span>
        <span class="table-cell bold">Resistance Testing and Results</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('11')">
        <span class="table-cell fixed-column">Figure 11</span>
        <span class="table-cell">Cumulative Resistance Testing Results by Resistance Category for {{this.$parent.haName}}, 2016 Q3–{{this.$parent.lastYear}} Q{{this.$parent.lastQuarter}}</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('12a')">
        <span class="table-cell fixed-column bold">Indicator 12</span>
        <span class="table-cell bold">AIDS-Defining Illness</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('12')">
        <span class="table-cell fixed-column">Figure 12</span>
        <span class="table-cell">AIDS Case Rate and Reports for {{this.$parent.haName}}, 2010–2016</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('13a')">
        <span class="table-cell fixed-column bold">Indicator 13</span>
        <span class="table-cell bold">HIV-Related Mortality</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('13')">
        <span class="table-cell fixed-column">Figure 13</span>
        <span class="table-cell">HIV-Related Deaths by Year for all BC</span>
      </a>
      <a class="table-row" href="javascript:void(0);" @click="goToByScroll('appendices')">
        <span class="table-cell fixed-column bold"><span>Appendices</span></span>
        <span class="table-cell"></span>
      </a>
    </div>
  </div>
</template>

<script>
  import * as $ from 'jquery';
  export default {
    mounted() {
      // if (this.$route.params.ha !== 'bc') {
      //   $('#app > div > div.table-contents.bottom-padded-2x > div:nth-child(3) > a:nth-child(52) > span.table-cell.fixed-column.bold > span').css({
      //     'background-color': 'rgba(255, 255, 0, 0.5)',
      //     'padding': '4px 0 4px 0'
      //   });
      // }
    },
    methods: {
      goToByScroll(id){
        // console.log(`Scrolling to ${id}...`);
        if (!$("#"+id).offset()) {
          // console.log(`Element not found: ${id}`);
          // console.log($("#"+id));
          return;
        }
        $('html,body').animate({scrollTop: $("#"+id).offset().top}, 'fast');
      }
    },
    name: 'tableContents',
    data () {
      return {
        msg: 'Home'
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bold {
    font-weight: bold;
  }

  .table-row {
    display: table;
  }

  .table-cell {
    display: table-cell;
    padding-bottom: 12px;
  }

  .fixed-column {
    width: 100px;
  }
</style>



// WEBPACK FOOTER //
// TableContents.vue?6c5a111c